// On document loaded, focus on the first input of the first gravityform on a page.
document.addEventListener("DOMContentLoaded", function() {
    const form = document.querySelector('main .gform_wrapper form');

    if (form === null) {
        return;
    }

    const isNewsletterForm = form.closest('.newsletter-form') !== null;
    const isAjaxForm = form.target.includes('ajax');

    if (isNewsletterForm || isAjaxForm) {
        return;
    }

    form.addEventListener("submit", () => {
        const loader = document.getElementsByClassName('custom-loader')[0];

        if (loader) {
            loader.classList.remove('hidden');
        }
    });
});


// WEBPACK FOOTER //
// ./scripts/custom/show-loader-on-gravity-form-submit.js